import React from 'react';
import './ads.scss';
import { useParams } from 'react-router-dom';
import AdsSinglePage from '../AdsSinglePage/AdsSinglePage';
import LiveAds from '../LiveAds/LiveAds';

const Ads = () => {
    const { profileId } = useParams(); // Destructure profileId from useParams
    
    // Add console log for debugging
    console.log('Ads component - profileId:', profileId);
    console.log('Ads component - profileId type:', typeof profileId);
    console.log('Ads component - profileId length:', profileId?.length);
    
    return <AdsSinglePage activeProfileId={profileId} />;
}

export default Ads;
